import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Table, Card, Loader, Dropdown, Icon, Popup} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {paths} from '../../../../common/dictionaries/urls';
import {pageSizes} from '../../../../common/constants/lists';
import TablePaginator from '../../../../common/components/tablePaginator';

class PartNumberCodeTable extends Component {
  constructor(props) {
    super(props);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {pageNumber, pageSize, pncList} = this.props;

    if (pncList.length === 0) {
      return;
    }

    if (pageNumber !== prevProps.pageNumber || pageSize !== prevProps.pageSize) {
      this.props.onUpdate();
    }
  }

  handlePageSizeChange(event, data) {
    this.props.changePartNumberCodeInformationPage(0);
    this.props.changePartNumberCodeInformationPageSize(data.value);
  }

  handlePageClick(value) {
    this.props.changePartNumberCodeInformationPage(value);
  }

  renderTableHeader() {
    return (
      <Table.Row>
        <Table.HeaderCell textAlign='center'>PNC</Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>Nombre</Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>Desc. Inglés</Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>Descripción General</Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>Grupo</Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>Uso</Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>Presentación/Empaque</Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>Composición</Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>Lado</Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>Vehículo</Table.HeaderCell>
        <Table.HeaderCell textAlign='center'>Pedido</Table.HeaderCell>
        <Table.HeaderCell textAlign='center' width={1}>Acciones</Table.HeaderCell>
      </Table.Row>
    );
  }

  renderLoaderOrPartNumberCodeInformation() {
    const {loading} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    if (!this.props.pncList.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan='100%'>
            No se encuentran datos disponibles con los filtros seleccionados
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderPartNumberCodeInformation();
  }

  renderPartNumberCodeInformation() {
    const {pncList} = this.props;
    const valueIfNull = '';
    return pncList.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.partNumberCode || valueIfNull}</Table.Cell>
          <Table.Cell textAlign='center'>{element.name || valueIfNull}</Table.Cell>
          <Table.Cell textAlign='center'>{element.englishDescription || valueIfNull}</Table.Cell>
          <Table.Cell textAlign='center'>{element.generalDescription || valueIfNull}</Table.Cell>
          <Table.Cell textAlign='center'>{element.group || valueIfNull}</Table.Cell>
          <Table.Cell textAlign='center'>{element.use || valueIfNull}</Table.Cell>
          <Table.Cell textAlign='center'>{element.presentation || valueIfNull}</Table.Cell>
          <Table.Cell textAlign='center'>{element.composition || valueIfNull}</Table.Cell>
          <Table.Cell textAlign='center'>{element.side || valueIfNull}</Table.Cell>
          <Table.Cell textAlign='center'>{element.vehicle || valueIfNull}</Table.Cell>
          <Table.Cell textAlign='center'>{element.order || valueIfNull}</Table.Cell>
          <Table.Cell textAlign='center' width={1}>
            <Popup
              trigger={
                <Link to={`/codigo-numero-parte/editar/${element.partNumberCode}`}
                  state={{
                    'editPnc': true,
                    'pncInfo': element,
                  }}
                >
                  <Icon name='write' color='blue' size='large' />
                </Link>
              }
              content='Editar'
            />

            <Popup
              trigger={
                <Link to={paths.ClonePartNumberCode}
                  state={{
                    'pncInfo': element,
                  }}
                >
                  <Icon name='copy' color='blue' size='large' />
                </Link>
              }
              content='Clonar'
            />
          </Table.Cell>

        </Table.Row>
      );
    });
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems} = this.props;
    
    if (totalItems <= pageSize) {
      return null;
    }

    if (this.props.pncList.length === 0) {
      return null;
    }

    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className = 'page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.handlePageSizeChange}
                />
              </span>
              <TablePaginator
                itemsCount = {totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.handlePageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    return (
      <div>
        <Card fluid raised>
          <div className='horizontal-scroll'>
            <Table striped>
              <Table.Header>
                {this.renderTableHeader()}
              </Table.Header>
              
              <Table.Body>
                {this.renderLoaderOrPartNumberCodeInformation()}
              </Table.Body>
            </Table>
          </div>
          <Table className='pagination-table'>
            {this.renderPagination()}
          </Table>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'pncList': state.allPartNumberCodes.list,
    'loading': state.allPartNumberCodes.loading,
    'pageNumber': state.allPartNumberCodes.offset,
    'pageSize': state.allPartNumberCodes.limit,
    'totalItems': state.allPartNumberCodes.count,
  };
};

const {
  addMessageBoxError,
  changePartNumberCodeInformationPage,
  changePartNumberCodeInformationPageSize,
} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  changePartNumberCodeInformationPage,
  changePartNumberCodeInformationPageSize,
})(PartNumberCodeTable);
